/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AdminWorkerJobState = {
    WorkerJobStateAvailable: 'available',
    WorkerJobStateScheduled: 'scheduled',
    WorkerJobStatePending: 'pending',
    WorkerJobStateRunning: 'running',
    WorkerJobStateRetryable: 'retryable',
    WorkerJobStateCompleted: 'completed',
    WorkerJobStateDiscarded: 'discarded',
    WorkerJobStateCancelled: 'cancelled'
} as const;
export type AdminWorkerJobState = typeof AdminWorkerJobState[keyof typeof AdminWorkerJobState];


export function instanceOfAdminWorkerJobState(value: any): boolean {
    for (const key in AdminWorkerJobState) {
        if (Object.prototype.hasOwnProperty.call(AdminWorkerJobState, key)) {
            if (AdminWorkerJobState[key as keyof typeof AdminWorkerJobState] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AdminWorkerJobStateFromJSON(json: any): AdminWorkerJobState {
    return AdminWorkerJobStateFromJSONTyped(json, false);
}

export function AdminWorkerJobStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminWorkerJobState {
    return json as AdminWorkerJobState;
}

export function AdminWorkerJobStateToJSON(value?: AdminWorkerJobState | null): any {
    return value as any;
}

export function AdminWorkerJobStateToJSONTyped(value: any, ignoreDiscriminator: boolean): AdminWorkerJobState {
    return value as AdminWorkerJobState;
}

